import Vue from 'vue'
import pgDialogMethod from './dialog-select-method.vue'

const DialogConstructor = Vue.extend(pgDialogMethod)

let instanceDialog
const instancesDialog = []
let seedDialog = 1

/**
 * 通过js调用弹窗表单
 * @param {object} options
 * @returns {Promise} {dialogData, onClose, type}
 */
export function pgDialogSelectService(options) {
  return new Promise((resolve) => {
    instanceDialog = new DialogConstructor()
    instanceDialog.id = `dialog-select-method${seedDialog++}`
    options.close = function () {
      pgDialogSelectService.close(instanceDialog.id)
    }
    options.beforeClose = async ({ dialogData, onClose, type }) => {
      resolve({ dialogData, onClose, type })
    }
    instanceDialog.$mount()
    document.body.appendChild(instanceDialog.$el)
    instanceDialog.show(options)
    instancesDialog.push(instanceDialog)
  })
}

pgDialogSelectService.close = function (id) {
  const index = instancesDialog.findIndex((ins) => ins.id === id)
  if (index > -1) {
    instancesDialog.splice(index, 1)
  }
}
